import React from "react";

import { useNavigate } from "react-router";

import { Topbar } from "@/components/ui";
import type { ProgrammePlatformClient } from "@/platform";
import type { NotificationFeedItem } from "@/server/types";

import { NotificationCentre } from "./NotificationCentre";
import { RouteAction } from "./RouteAction";
import { RouteBreadcrumb } from "./RouteBreadcrumb";
import { RouteGuideLink } from "./RouteGuideLink";
import { UserMenu } from "./UserMenu";

interface WorkspaceTopbarProps {
  client: ProgrammePlatformClient;
  displayName: string;
  email: string;
  accountRole: string;
  programmeCreator: boolean;
  onNotificationOpen: (notification: NotificationFeedItem) => void;
  onSwitchUser: () => void;
  onLogout: () => void;
}

/** The workspace topbar: route breadcrumb and action, guide page, notifications, user menu. */
export function WorkspaceTopbar({
  client,
  displayName,
  email,
  accountRole,
  programmeCreator,
  onNotificationOpen,
  onSwitchUser,
  onLogout,
}: WorkspaceTopbarProps): React.ReactElement {
  const navigate = useNavigate();
  return (
    <Topbar
      data-testid="workspace-topbar"
      breadcrumb={<RouteBreadcrumb />}
      action={<RouteAction />}
      utilities={
        <>
          <RouteGuideLink />
          <NotificationCentre client={client} onOpen={onNotificationOpen} />
          <UserMenu
            displayName={displayName}
            email={email}
            accountRole={accountRole}
            programmeCreator={programmeCreator}
            onOpenSettings={() => {
              navigate("/settings");
            }}
            onSwitchUser={onSwitchUser}
            onLogout={onLogout}
          />
        </>
      }
    />
  );
}
